require('./utils/polyfills');
require('./config');

import Vue from 'vue';
import axios from 'axios';
import Form from './core/Form';
import Promise from 'promise-polyfill';
import Moment from 'moment';

// Polyfills
if (!window.Promise) {
  window.Promise = Promise;
}
// Adding a interceptor for every request from axios
window.axiosWithoutLoading = axios.create();
window.Vue = Vue;
window.axios = axios;
window.Form = Form;
window.moment = Moment;

Vue.directive('submit', {
  inserted: (el) => {
    EventBus.$on('loading-show', () => el.setAttribute('disabled', 'true'));
    EventBus.$on('loading-hide', () => window.setTimeout(() => el.removeAttribute('disabled'), 300));
  }
});

/*
 * Constante Event para facilitar a comunicação entre componentes
 * principalmente quando estamos falando de componentes irmãos.
 * Seu uso é feito através dos métodos $emit e $on
 */
window.EventBus = new Vue();

window.axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest'
}

window.axiosWithoutLoading.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest'
}

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
  window.axiosWithoutLoading.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
